<template>
  <v-app :style="{
                  backgroundColor:
                  changeColor ? '#F0F0F0' : 'white',
                }" >
    <div>
      <v-app-bar
        v-show="!hiddenToolbar"
        fixed
        app
        color="primary"
        dense
        dark
        class="hidden-print-only"
      >
        <v-app-bar-nav-icon
          @click.stop="drawer = !drawer"
          v-if="!showComputer"
        ></v-app-bar-nav-icon>
        <v-btn v-if="showComputer" icon text @click="$router.back()">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

                <v-toolbar-title><v-btn @focus="selectedComputer = 'home'"
        :style="{
                  backgroundColor:
                  selectedComputer == 'home' ? '#000080' : 'transparent',
                }" text 
                @click="changeRouter('/home')" style="text-transform: none">Chan Nyein Dental Clinic</v-btn> </v-toolbar-title>

        <div class="flex-grow-1"></div>
        <v-toolbar-items v-if="showComputer">
          <v-btn v-if="uiAccept.registration" @focus="selectedComputer = 'vsall'"
        :style="{
                  backgroundColor:
                  selectedComputer == 'vsall' ? '#000080' : 'transparent',
                }" text  @click="changeRouter('/vsall')"  style="text-transform: none">
                <v-icon>mdi-cloud-print</v-icon></v-btn>
          <v-btn v-if="uiAccept.registration" @focus="selectedComputer = 'user'"
        :style="{
                  backgroundColor:
                  selectedComputer == 'user' ? '#000080' : 'transparent',
                }" text @click="changeRouter('/user')"  style="text-transform: none">Registration</v-btn>
                
          <v-menu open-on-hover offset-y left v-if="showComputer && (uiAccept.newpatientrecord || uiAccept.patientrecordlist )">
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on" 
        :style="{
                  backgroundColor:
                  selectedComputer == 'pr' ? '#000080' : 'transparent',
                }">
                <span class="ml-2 d-none d-sm-flex" style="text-transform: none"
                  >Patient Record</span
                >
                <v-icon class="d-none d-sm-flex">mdi-menu-down-outline</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, index) in records"
                  :key="index"
                  @focus="selectedComputer = 'pr'"
                  @click="changeRouter(item.value)"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <v-menu open-on-hover offset-y left v-if="showComputer && (uiAccept.sale || uiAccept.salelist )">
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on" 
        :style="{
                  backgroundColor:
                  selectedComputer == 'sale' ? '#000080' : 'transparent',
                }">
                <span class="ml-2 d-none d-sm-flex" style="text-transform: none"
                  >Sale</span
                >
                <v-icon class="d-none d-sm-flex">mdi-menu-down-outline</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, index) in sale"
                  :key="index"
                  @click="changeRouter(item.value)"
                  @focus="selectedComputer = 'sale'"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <v-menu open-on-hover offset-y left v-if="showComputer && (uiAccept.purchase || uiAccept.purchaselist )">
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on" 
        :style="{
                  backgroundColor:
                  selectedComputer == 'pur' ? '#000080' : 'transparent',
                }">
                <span class="ml-2 d-none d-sm-flex" style="text-transform: none"
                  >Purchase</span
                >
                <v-icon class="d-none d-sm-flex">mdi-menu-down-outline</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, index) in purchase"
                  :key="index"
                  @click="changeRouter(item.value)"
                  @focus="selectedComputer = 'pur'"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <v-menu open-on-hover offset-y left v-if="showComputer && (uiAccept.payment || uiAccept.income || uiAccept.expense )">
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on" 
        :style="{
                  backgroundColor:
                  selectedComputer == 'pay' ? '#000080' : 'transparent',
                }">
                <span class="ml-2 d-none d-sm-flex" style="text-transform: none"
                  >Payments</span
                >
                <v-icon class="d-none d-sm-flex">mdi-menu-down-outline</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, index) in payments"
                  :key="index"
                  @click="changeRouter(item.value)"
                  @focus="selectedComputer = 'pay'"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <v-menu open-on-hover offset-y left v-if="showComputer && (uiAccept.profitloss ||  uiAccept.paymentreport || uiAccept.treatmentreport || uiAccept.patientdebitreport || uiAccept.debitcreditreport || uiAccept.incomereport || uiAccept.expensereport || uiAccept.stockonhandreport || uiAccept.salereport || uiAccept.purchasereport || uiAccept.labfeereport )">
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on" 
        :style="{
                  backgroundColor:
                  selectedComputer == 'rep' ? '#000080' : 'transparent',
                }">
                <span class="ml-2 d-none d-sm-flex" style="text-transform: none"
                  >Reports</span
                >
                <v-icon class="d-none d-sm-flex">mdi-menu-down-outline</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, index) in reports"
                  :key="index"
                  @click="changeRouter(item.value)"
                  @focus="selectedComputer = 'rep'"
                  
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <v-menu open-on-hover offset-y left v-if="showComputer && (uiAccept.township || uiAccept.useraccount || uiAccept.branch || uiAccept.transfer || uiAccept.product || uiAccept.treatment || uiAccept.chiefcomplaintype || uiAccept.diagnosistype || uiAccept.pastmedicalhistory || uiAccept.category || uiAccept.unit )">
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on" 
        :style="{
                  backgroundColor:
                  selectedComputer == 'set' ? '#000080' : 'transparent',
                }">
                <span class="ml-2 d-none d-sm-flex" style="text-transform: none"
                  >Settings</span
                >
                <v-icon class="d-none d-sm-flex">mdi-menu-down-outline</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, index) in settings"
                  :key="index"
                  @click="changeRouter(item.value)"
                  @focus="selectedComputer = 'set'"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu> 

          

          <v-btn v-if="uiAccept.appointment" @focus="selectedComputer = 'app'"
        :style="{
                  backgroundColor:
                  selectedComputer == 'app' ? '#000080' : 'transparent',
                }" text @click="changeRouter('/appoint')"  style="text-transform: none">Appointment
                
                 <v-badge color="error" :content="appCount" v-if="appCount!=0"></v-badge>
      </v-btn>
          <v-menu open-on-hover offset-y left>
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on">
                <span class="ml-2 d-none d-sm-flex" style="text-transform: none"
                  >{{loginUser.profileName }}</span
                >
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, index) in profileList"
                  :key="index"
                  @click="changeRouter(item.value)"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </v-app-bar>
      <v-navigation-drawer v-model="drawer" fixed temporary>
        <v-list>
          <v-list-item class="px-2">
            <v-list-item-avatar>
              <v-img src="/info/logoprint.png"></v-img>
            </v-list-item-avatar>
            <v-list-item-title class="text-h6">
                {{loginUser.profileName }}
              </v-list-item-title>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>
        <v-list
          nav
          dense
        >
        <v-list-item 
        @focus="selectIndex = 'user'"
        :style="{
                  backgroundColor:
                    selectIndex == 'user' ? '#def3ff' : 'transparent',
                }"
                @click="changeRouter('/user')">
        <v-list-item-icon >
          <v-icon>mdi-account</v-icon>
        </v-list-item-icon>

        <v-list-item-title >Registration</v-list-item-title>
        </v-list-item>
        <v-list-item 
        @focus="selectIndex = 'app'"
        :style="{
                  backgroundColor:
                    selectIndex == 'app' ? '#def3ff' : 'transparent',
                }"
                @click="changeRouter('/appoint')">
        <v-list-item-icon >
          <v-icon>mdi-gauge</v-icon>
        </v-list-item-icon>

        <v-list-item-title >Appointment</v-list-item-title>
        </v-list-item>
        <v-list-item  v-if="uiAccept.newpatientrecord"
        @focus="selectIndex = 'new'"
        :style="{
                  backgroundColor:
                    selectIndex == 'new' ? '#def3ff' : 'transparent',
                }"
                @click="changeRouter('/newrecord')">
        <v-list-item-icon >
          <v-icon>mdi-tooth-outline</v-icon>
        </v-list-item-icon>

        <v-list-item-title >New Patient Record</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="uiAccept.patientrecordlist"
        @focus="selectIndex = 'rl'"
        :style="{
                  backgroundColor:
                    selectIndex == 'rl' ? '#def3ff' : 'transparent',
                }"
                @click="changeRouter('/recordlist')">
        <v-list-item-icon >
          <v-icon>mdi-tooth-outline</v-icon>
        </v-list-item-icon>

        <v-list-item-title >Patient Record List</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="uiAccept.sale"
        @focus="selectIndex = 'sale'"
        :style="{
                  backgroundColor:
                    selectIndex == 'sale' ? '#def3ff' : 'transparent',
                }" @click="changeRouter('/sale')">
        <v-list-item-icon >
          <v-icon >mdi-sale</v-icon>
        </v-list-item-icon>

        <v-list-item-title>Sale</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="uiAccept.salelist"
        @focus="selectIndex = 'salelist'"
        :style="{
                  backgroundColor:
                    selectIndex == 'salelist' ? '#def3ff' : 'transparent',
                }" @click="changeRouter('/salelist')">
        <v-list-item-icon >
          <v-icon >mdi-clipboard-list</v-icon>
        </v-list-item-icon>

        <v-list-item-title>Sale List</v-list-item-title>
      </v-list-item>
        <v-list-item v-if="uiAccept.purchase"
        @focus="selectIndex = 'pur'"
        :style="{
                  backgroundColor:
                    selectIndex == 'pur' ? '#def3ff' : 'transparent',
                }" @click="changeRouter('/pur')">
        <v-list-item-icon >
          <v-icon >mdi-storefront</v-icon>
        </v-list-item-icon>

        <v-list-item-title>Purchase</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="uiAccept.purchaselist"
        @focus="selectIndex = 'purlist'"
        :style="{
                  backgroundColor:
                    selectIndex == 'purlist' ? '#def3ff' : 'transparent',
                }" @click="changeRouter('/purlist')">
        <v-list-item-icon >
          <v-icon >mdi-clipboard-list-outline</v-icon>
        </v-list-item-icon>

        <v-list-item-title>Purchase List</v-list-item-title>
      </v-list-item>
      <v-list-group
        prepend-icon="mdi-credit-card-outline"
      >
        <template v-slot:activator>
          <v-list-item-title>Payments</v-list-item-title>
        </template>
          <v-list-item
            v-for="(item, i) in payments"
            :key="i"
            link
            @click="changeRouter(item.value)"
            @focus="selectIndex = item.value"
            :style="{
                  backgroundColor:
                    selectIndex == item.value ? '#def3ff' : 'transparent',
                }"
          >
          <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="item.title"></v-list-item-title> 
          </v-list-item>
      </v-list-group>
      <v-list-group
        prepend-icon="mdi-chart-box"
      >
        <template v-slot:activator>
          <v-list-item-title>Reports</v-list-item-title>
        </template>
          <v-list-item
            v-for="(item, i) in reports"
            :key="i"
            link
            @click="changeRouter(item.value)"
            @focus="selectIndex = item.value"
            :style="{
                  backgroundColor:
                    selectIndex == item.value ? '#def3ff' : 'transparent',
                }"
          >
          <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="item.title"></v-list-item-title> 
          </v-list-item>
      </v-list-group>
      <v-list-group
        prepend-icon="mdi-cog-outline"
        
      >
        <template v-slot:activator>
          <v-list-item-title>Settings</v-list-item-title>
        </template>
          <v-list-item
            v-for="(item, i) in settings"
            :key="i"
            link
            @click="changeRouter(item.value)"
            @focus="selectIndex = item.value"
            :style="{
                  backgroundColor:
                    selectIndex == item.value ? '#def3ff' : 'transparent',
                }"
          >
          <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item>
      </v-list-group>
      <v-list-group
        prepend-icon="mdi-face"
        
      >
        <template v-slot:activator>
          <v-list-item-title>My Profile</v-list-item-title>
        </template>
          <v-list-item
            v-for="(item, i) in profileList"
            :key="i"
            link
            @click="changeRouter(item.value)"
            @focus="selectIndex = item.value"
            :style="{
                  backgroundColor:
                    selectIndex == item.value ? '#def3ff' : 'transparent',
                }"
          >
          <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item>
      </v-list-group>
        </v-list>
        <template v-slot:append>
          <div class="pa-2">
            <v-btn
              class="red--text"
              block
              rounded
              outlined
              @click="changeRouter('/logout')"
            >
              <v-icon>mdi-logout</v-icon>Logout
            </v-btn>
          </div>
        </template>
      </v-navigation-drawer>
      <div class="mt-12 hidden-print-only"></div>
        <v-container fluid class="mt-0 pa-0">
        <v-progress-linear
          v-if="loading"
          fixed
          :indeterminate="loading"
          color="primary"
        ></v-progress-linear>
        <router-view :hideToolbar="hideToolbar" />
      </v-container>
      <!-- <v-content>
        <v-progress-linear
          v-if="loading"
          fixed
          :indeterminate="loading"
          color="primary"
        ></v-progress-linear>
        <router-view :hideToolbar="hideToolbar" />
      </v-content> -->
      <div>
        <v-dialog v-model="logoutModel" persistent max-width="350">
          <v-card>
            <v-card-title class="title">ထွက်ရန် သေချာပြီလား?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="logoutModel = false"
                >မလုပ်ပါ</v-btn
              >
              <v-btn color="primary" depressed @click="logout">ထွက်မည်</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <div>
        <v-dialog v-model="passwordModel" persistent max-width="400">
          <v-form ref="form" v-model="valid">
            <v-card>
              <v-card-title class="headline"
                >စကား၀ှက် ပြောင်းတော့မှာလား?</v-card-title
              >
              <v-card-text class="pb-0">
                <v-text-field
                  :append-icon="showOld ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showOld ? 'text' : 'password'"
                  @click:append="showOld = !showOld"
                  :rules="passwordOldRule"
                  v-model="password.old"
                  label="Old Password"
                  name="oldPassword"
                  placeholder=" "
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  :append-icon="showNew ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showNew ? 'text' : 'password'"
                  @click:append="showNew = !showNew"
                  :rules="passwordNewRule"
                  v-model="password.new"
                  label="New Password"
                  name="newPassword"
                  placeholder=" "
                  outlined
                  dense
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text @click="cancelChangePassword"
                  >မပြောင်းတော့ပါ</v-btn
                >
                <v-btn
                  color="primary"
                  :disabled="!valid"
                  depressed
                  @click="changePassword"
                  >ပြောင်းမည်</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </div>
    </div>
  </v-app>
</template>

<script>
import axios from "../src/config";
import accountUserService from "./service/UserAccountService";
import appService from "./service/AppointService";
export default {
  mounted: function () {
   
    this.$router.afterEach((to, from) => {
      const isPublic = to.matched.some((record) => record.meta.public);
      this.eventCount++;
      if (!isPublic) {
        this.$_.delay(() => {
          if (this.eventCount == 1) {
            this.mini = true;
            this.eventCount = 0;
          } else {
            this.eventCount--;
          }
        }, 20000);
      }
    });
    
  },
  data() {
    return {
    changeColor:true,
      hiddenToolbar: true,
      logoutModel: false,
      passwordModel: false,
      showOld: false,
      showNew: false,
      password: {},
      valid: true,
      passwordOldRule: [(v) => !!v || "Old Password is required"],
      passwordNewRule: [(v) => !!v || "New Password is required"],
      setting: {},
      limitDialog: false,
      loginUser: "",
      loadingCount: 0,
      loading: false,
      eventCount: 0,
      drawer: false,
      mini: true,
      uiAccept:{},
      records: [],
      sale: [],
      purchase: [],
      settings: [],
      reports: [],
      payments: [],
      fromDate: "",
      toDate: "",
      fromPicker: new Date().toISOString().substr(0, 10),
      toPicker: new Date().toISOString().substr(0, 10),
      appCount : 0,
      profileList: [
        {
          title: "Change Password",
          icon: "mdi-lock",
          value: "/change_password",
        },
        {
          title: "Logout",
          icon: "mdi-logout",
          value: "/logout",
        },
      ],
      selectIndex:"home",
      selectedComputer:"home"
    };
  },
  props: {},
  mounted: function () {
    this.hiddenToolbar = false;
    this.loginMounted();
    axios.interceptors.request.use((config) => {
      this.loadingCount++;
      if (!this.loading) {
        this.loading = true;
      }
      return config;
    });
    axios.interceptors.response.use(
      (response) => {
        this.loadingCount--;
        if (this.loadingCount == 0 && this.loading) {
          this.loading = false;
        }
        return response;
      },
      (error) => {
        if (error.isAxiosError && error.message == "Network Error") {
          this.$swal("အင်တာနက် လိုင်းမကောင်းပါ", error.message, "error");
          this.loadingCount = 1;
          this.loading = false;
        }
        if (error.response.data != null && error.response.data.status == 401) {
          this.$swal(
            "Authentication Error",
            "ထွက်မည် ခလုတ်နှိပ်ပေးပါ",
            "error"
          );
          this.changeRouter("/logout");
          this.logout();
        }
        this.loadingCount--;
        if (this.loadingCount == 0 && this.loading) {
          this.loading = false;
        }
        return Promise.reject(error);
      }
    );
  },
  computed: {
    showComputer() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return false;
        case "sm":
          return false;
        case "md":
          return true;
        case "lg":
          return true;
        case "xl":
          return true;
      }
    },
    isLogin: function () {
      let token = this.$store.state.userAccount.password;
      if (token == "") {
        return false;
      } else {
        axios.defaults.headers.common["Authorization"] = `dental${token}`;
        this.uiAcceptMethod();
        return true;
      }
    },
  },
  methods: {
    formatDate(datePicker) {
      const [year, month, day] = datePicker.split("-");
      return `${day}-${month}-${year}`;
    },
    getAppointmentCount:function(){
      this.fromDate = this.formatDate(this.fromPicker);
    this.toDate = this.formatDate(this.toPicker);
      appService
        .getAppointCount(this.fromDate, this.toDate)
        .then((response) => {
           this.appCount = response;
        })
        .catch((error) => {
          this.$swal("Fail!", error.response.data.message, "error");
        });
    },
    clickDrawer: function (item) {
      this.drawer = false;
      this.changeRouter(item.value);
    },
    changePassword: function () {
      accountUserService
        .changePassword(this.password.old, this.password.new)
        .then((response) => {
          if (response > 0) {
            this.$swal("Successful", "Change Password", "success");
            this.logout();
          } else {
            this.$swal("unSuccessful", "Change Password", "error");
          }
          this.password = {
            old: "",
            new: "",
          };
        });
      this.passwordModel = false;
    },
    cancelChangePassword: function () {
      this.passwordModel = false;
      this.password = {};
    },
    hideToolbar: function (hide,print) {
      this.hiddenToolbar = hide;
      this.changeColor = print;
      this.loginMounted();
    },
    changeRouter: function (path) {
      if (path == "/logout") {
        this.$store.commit("updateUserAccount", {
        userName: "",
        password: "",
        role: "",
      });
      this.hiddenToolbar = true;
        this.$router.push("/login").catch(() => {});
      } else if (path == "/change_password") {
        this.passwordModel = true;
      } else {
        this.$router
          .push({
            path: path,
          })
          .catch(() => {});
      }
      this.changeColor = true;
    },
    logout: function () {
      this.$store.commit("updateUserAccount", {
        userName: "",
        password: "",
        role: "",
      });
      this.changeRouter("/login");
      location.reload();
      this.logoutModel = false;
      this.hiddenToolbar = true;
    },
    loginMounted() {
      if (this.isLogin) {
        this.loginUser = this.$store.state.userAccount;
        this.getAppointmentCount();
        this.hiddenToolbar = false;
      } else {
        this.hiddenToolbar = true;
        this.$router.push("/login").catch(() => {});
      }
    },
    uiAcceptMethod:function(){
      accountUserService
        .getUiByUserId()
        .then((response) => {
          this.uiAccept = Object.assign({},response);
          this.$store.commit("updateUiAccept", response);
        })
        .catch((err) => {
          this.$swal("Failed", err.response.data.message, "error");
        });
    },
  },
  watch: {
    
   
     uiAccept:function(){
      

      this.records.splice(0);
      if(this.uiAccept.newpatientrecord){
          this.records.push({
            title: "New Patient Record",
          icon: "mdi-tooth-outline",
          value: "/newrecord",
        });
      }
       if(this.uiAccept.patientrecordlist){
          this.records.push({
            title: "Patient Record List",
          icon: "mdi-tooth-outline",
          value: "/recordlist",
        });
      }

       this.payments.splice(0);
      if(this.uiAccept.payment){
          this.payments.push({
            title: "Payment",
          icon: "mdi-cash-plus",
          value: "/payment",
        });
      }
       if(this.uiAccept.income){
          this.payments.push({
            title: "Income",
          icon: "mdi-credit-card-marker",
          value: "/income",
        });
      }
      if(this.uiAccept.expense){
          this.payments.push({
            title: "Expense",
          icon: "mdi-credit-card-settings-outline",
          value: "/expense",
        });
      }


        this.reports.splice(0);
        if(this.uiAccept.paymentreport){
          this.reports.push({
            title: "Payment",
          icon: "mdi-cash-100",
          value: "/reportbt",
        });
      }
      if(this.uiAccept.treatmentreport){
          this.reports.push({
            title: "Treatment Report",
          icon: "mdi-credit-card-settings-outline",
          value: "/treatmentrpt",
        });
      }

       if(this.uiAccept.patientdebitreport){
          this.reports.push({
            title: "Patient Debit Report",
          icon: "mdi-account-cash-outline",
          value: "/reportpay",
        });
      }

       if(this.uiAccept.debitcreditreport){
          this.reports.push({
            title: "Debit/Credit Report",
          icon: "mdi-cash-multiple",
          value: "/debitcredit",
        });
      }

      if(this.uiAccept.stockonhandreport){
          this.reports.push({
            title: "Stock On Hand",
          icon: "mdi-scale-balance",
          value: "/soh",
        });
      }

      if(this.uiAccept.salereport){
          this.reports.push({
            title: "Sales Report",
          icon: "mdi-sale",
          value: "/reportsale",
        });
      }

      if(this.uiAccept.purchasereport){
          this.reports.push({
            title: "Purchase Report",
          icon: "mdi-storefront",
          value: "/reportpur",
        });
      }
      if(this.uiAccept.labfeereport){
          this.reports.push({
            title: "Lab Fee Report",
            icon:"mdi-microscope",
          
          value: "/reportlabfee",
        });
      }
      if(this.uiAccept.incomereport){
          this.reports.push({
            title: "Income Report",
          icon: "mdi-cash-plus",
          value: "/ri",
        });
      }
      if(this.uiAccept.expensereport){
          this.reports.push({
            title: "Expense Report",
          icon: "mdi-cash-minus",
          value: "/re",
        });
      }
      if(this.uiAccept.profitloss){
          this.reports.push({
            title: "Profit & Loss",
          icon: "mdi-credit-card-settings-outline",
          value: "/profitloss",
        });
      }

      this.settings.splice(0);
      if(this.uiAccept.transfer){
          this.settings.push({
            title: "Transfer",
          icon: "mdi-chart-ppf",
          value: "/transfer",
        });
      }
      if(this.uiAccept.product){
          this.settings.push({
            title: "Product",
          icon: "mdi-chart-ppf",
          value: "/product",
        });
      }
      if(this.uiAccept.treatment){
          this.settings.push({
            title: "Treatment",
          icon: "mdi-tooth",
          value: "/st",
        });
      }
      if(this.uiAccept.chiefcomplaintype){
          this.settings.push({
            title: "Chief Complain Type",
          icon: "mdi-home-assistant",
          value: "/ct",
        });
      }
      if(this.uiAccept.diagnosistype){
          this.settings.push({
            title: "Diagnosis Type",
          icon: "mdi-call-merge",
          value: "/dt",
        });
      }
      if(this.uiAccept.pastmedicalhistory){
          this.settings.push({
            title: "Past Medical History",
          icon: "mdi-medical-bag",
          value: "/pmt",
        });
      }
      if(this.uiAccept.category){
          this.settings.push({
            title: "Category",
          icon: "mdi-shape",
          value: "/category",
        });
      }

      if(this.uiAccept.unit){
          this.settings.push({
            title: "Unit",
          icon: "mdi-power-socket-uk",
          value: "/unit",
        });
      }
    if(this.uiAccept.township){
          this.settings.push({
            title: "Township",
          icon: "mdi-home-city",
          value: "/ts",
        });
      }
      if(this.uiAccept.branch){
          this.settings.push({
            title: "Branch",
          icon: "mdi-office-building",
          value: "/branch",
        });
      }
      if(this.uiAccept.useraccount){
          this.settings.push({
            title: "User Account",
          icon: "mdi-account",
          value: "/user",
        });
      }

if(this.$store.state.userAccount.role=='ADMIN'){
          this.settings.push({
          title: "UI Accept",
          icon: "mdi-access-point",
          value: "/ui",
        });
      }
      this.sale.splice(0);
      if(this.uiAccept.sale){
                this.sale.push({
                  title: "Sale",
                icon: "mdi-sale",
                value: "/sale",
              });
        }
        if(this.uiAccept.salelist){
                this.sale.push({
                  title: "Sale List",
                icon: "mdi-clipboard-list",
                value: "/salelist",
              });
        }

        this.purchase.splice(0);
      if(this.uiAccept.purchase){
                this.purchase.push({
                  title: "Purchase",
                icon: "mdi-storefront",
                value: "/pur",
              });
        }
        if(this.uiAccept.purchaselist){
                this.purchase.push({
                  title: "Purchase List",
                icon: "mdi-clipboard-list-outline",
                value: "/purlist",
              });
        }

  
     }
  },
  components: {},
  name: "App",
};
</script>
<style scope>
html::-webkit-scrollbar {
  width: 0px;
}

html::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.699);
  border-radius: 3px;
}

html::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: #4caf50;
  padding: 3px;
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5);
}

div::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

div::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.699);

  border-radius: 3px;
}

div::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: #4caf50;
  -webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0.5);
}
</style>